import { Box, DialogContent, Modal } from "@mui/material"
import { setFocus } from "@noriginmedia/norigin-spatial-navigation"
import React, { useRef } from "react"

import { DGText } from "../../components/common/DGText"
import { Footer } from "../../components/common/Footer"
import { useModalDismiss } from "../../hooks/use-modal-dismiss"
import { useModalScroll } from "../../hooks/use-modal-scroll"
import { useTransitions } from "../../hooks/use-transitions"
import useTranslate from "../../hooks/use-translate"
import { comb, s } from "../../utilities/common"
import { privacyLink } from "../../utilities/constants"
import { theme, TI } from "../../utilities/theme"
import { usePauseFocus } from "../../utilities/use-pause-focus"

import { OnboardingFocusKeys } from "./components/onboarding-focus-keys"

export const PrivacyPolicyModal = ({ open }: { open: comb<boolean> }) => {
  if (!open.val) return null
  return <Screen open={open} />
}

const Screen = ({ open }: { open: comb<boolean> }) => {
  const t = useTranslate()
  const scrollRef = useRef<HTMLElement>(null)

  useModalScroll(scrollRef)
  const FocusTrap = usePauseFocus(
    `${t("onboarding__tracking_title")}: ${t(
      "privacy__tracking_info_text_with_placeholder",
      [privacyLink],
    )}`,
  )

  useModalDismiss(() => {
    setFocus(OnboardingFocusKeys.PrivacyPolicy)
    open.set(false)
  })
  const transition = useTransitions()

  return (
    <Modal
      open={open.val}
      sx={{
        height: "100%",
        width: "100%",
        backgroundColor: "#1A2436",
        "& > *": { transition: "none !important" },
      }}
    >
      <DialogContent
        sx={{
          height: "100%",
          width: "100%",
          backgroundColor: theme.palette.primary.variant,
          position: "absolute",
          overflowY: "visible",
        }}
      >
        <Box ref={scrollRef} style={{ transition }}>
          <FocusTrap />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              willChange: "transform",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                width: s("1160px"),
                mt: s("184px"),
              }}
            >
              <DGText
                tx={TI.H05tv}
                sx={{
                  color: theme.palette.white.main,
                }}
              >
                {t("onboarding__tracking_title")}
              </DGText>
              <DGText
                tx={TI.Subheadline05tv}
                sx={{
                  color: theme.palette.white[70],
                  whiteSpace: "pre-wrap",
                  mt: s("32px"),
                }}
              >
                {t("privacy__tracking_info_text_with_placeholder", [
                  privacyLink,
                ])}
              </DGText>
            </Box>
            <Footer />
          </Box>
        </Box>
      </DialogContent>
    </Modal>
  )
}
